import React from "react"
import { useDispatch } from "react-redux";
import Router from "router";

function App() {

  return (
    <Router />
  );
}

export default App;


